module.exports = "/assets/data/24238e39186988e46e77cff1919cc1f5-TR7.data.json";